import { useState, useEffect } from 'react';

function getInitialState(query, defaultState) {
  if (defaultState !== undefined) {
    return defaultState;
  }
  if (typeof window !== 'undefined') {
    return window.matchMedia(query).matches;
  }
  return false;
}
/**
 * Custom hook that returns boolean value based on media query dimensions
 * @param query - media query (e.g. "(min-width: 1024px)")
 * @param defaultState - optional default state to apply initial styles
 * @returns - boolean value where browser dimensions satisfies media query
 */
const useMediaQuery = (query, defaultState) => {
  const initialState = getInitialState(query, defaultState);
  const [matches, setMatches] = useState(initialState);
  useEffect(() => {
    const mql = window.matchMedia(query);
    setMatches(mql.matches);
    const onChange = () => setMatches(!!mql.matches);
    if ('addEventListener' in mql) {
      mql.addEventListener('change', onChange);
    } else if ('addListener' in mql) {
      // @ts-ignore Support Safari versions lower than 14
      mql.addListener(onChange);
    }
    return () => {
      if ('removeEventListener' in mql) {
        return mql.removeEventListener('change', onChange);
      }
      if ('removeListener' in mql) {
        // @ts-ignore Support Safari versions lower than 14
        return mql.removeListener(onChange);
      }
    };
  }, [query]);
  return matches;
};

export { useMediaQuery };
